import { render, staticRenderFns } from "./AssetHeaderCard.vue?vue&type=template&id=53636bab"
import script from "./AssetHeaderCard.vue?vue&type=script&lang=js"
export * from "./AssetHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports